<template>
<div id="rf_checkbox">
    <div class="cb-icon"
        :class="{'cb-icon-selected': isActive, 'dist': registerUserType == 'dist', 'sale': registerUserType == 'sale'}"
        v-show="!isActive"
        @click="toggleCheckBox()"></div>
    <div class="box-marketing cb-icon"
        :class="{'cb-icon-selected': isActive, 'dist': registerUserType == 'dist', 'sale': registerUserType == 'sale'}"
        v-show="isActive"
        @click="toggleCheckBox()"></div>
    <label class="bi-cb-lbl">{{textLbl}}</label>
</div>
</template>
<script>
export default {
    name: "InputCheckBox",
    props: {
        //v-model
        value: Boolean,
        //props
        textLbl: String,
        all:     Boolean,
        email:   Boolean,
        sms:     Boolean,
        line:    Boolean
    },
    watch: {
       value: function(val) {
           this.isActive = val;
       },
    },
    computed: {
        registerUserType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            isActive: true
        };
    },
    created: function() {
        this.isActive = this.value;
    },
    methods: {
        toggleCheckBox: function () {
            this.isActive = !this.isActive;
            if (this.all) {
                this.$emit('onClickAll', this.isActive);
            } else if (this.email) {
                this.$emit('onAcceptEmail', this.isActive);
            } else if (this.sms) {
                this.$emit('onAcceptSMS', this.isActive);
            } else {
                this.$emit('onAcceptLine', this.isActive);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./baseinput.scss";
@import "@/style/base/common.scss";
#rf_checkbox {
    align-items: center;
    @include checkbox-wrapper("../../assets/icon/ic-checkbox-active-new.svg", "../../assets/image/Register/ic-cb-inactive.svg");

    .cb-icon {
        margin: 0 10px 0 0;

        &.cb-icon-selected{
            &.dist {
                background-image: url("../../assets/image/Register/ic-cb-dist-active.svg");
            }

            &.sale {
                background-image: url("../../assets/image/Register/ic-cb-sale-active.svg");
            }
        }
    }
    .cb-txt {
        .cb-link {
            color: $green-00987F;
            &.dist {
                color: $dist;
            }

            &.sale {
                color: $sale;
            }
        }
    }
    .bi-cb-lbl {
        margin-bottom: -2px;
    }
}
</style>
